import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Header from './components/Header';
import ScrollToTop from './components/ScrollToTop';
import MainNav from './components/MainNav';
import MobileNav from './components/MobileNav';
import PromoBanner from './components/PromoBanner';
import MainFooter from './components/MainFooter';
import MobileFooter from './components/MobileFooter';
import Seo from "./components/Seo";

import NotFound from './pages/not-found/NotFound';

import Home from './pages/home/Home';
import About from './pages/about/About';
import Menu from './pages/menu/Menu';
import Cakes from './pages/menu/cakes/Cakes';
import Cupcakes from './pages/menu/cupcakes/Cupcakes';
import Cookies from './pages/menu/cookies/Cookies';
import Cakesicles from './pages/menu/cakesicles/Cakesicles';
import TartsBarsBrownies from './pages/menu/tarts-bars-brownies/TartsBarsBrownies';
import Services from './pages/services/Services';
import PrivateEvents from './pages/services/private-events/PrivateEvents';
import CorporateEvents from './pages/services/corporate-events/CorporateEvents';
import Weddings from './pages/services/weddings/Weddings';
import HolidayOrders from './pages/services/holiday-orders/HolidayOrders';
import EquipmentRental from './pages/services/equipment-rental/EquipmentRental';
import { SERVICES_ENABLED } from './common/constants';
import Gallery from './pages/gallery/Gallery';
import Classes from './pages/classes/Classes';
import Order from './pages/order/Order';
import FAQs from './pages/faqs/FAQs';

import './styles/reset.scss';
import './styles/global.scss';
import './App.scss';

function App() {

    const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= 768);

    useEffect(() => {
        function handleResize() {
            setIsMobile(window.innerWidth <= 768);
        }

        handleResize();
        window.addEventListener('resize', handleResize);

        //Cleanup event listener on component unmount
        return () => {
            window.removeEventListener('resize', handleResize);
        }

    }, []);

    return (
        <Router>
            <Seo />
            <ScrollToTop />
            <div className="main-container">
                <div className="sticky">
                    {isMobile && <MobileNav />}
                    <Header />
                    <PromoBanner />
                    {!isMobile && <MainNav />}
                </div>
                <div className="page-wrapper">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/menu" element={<Menu />} />
                        <Route path="/menu/cakes" element={<Cakes />} />
                        <Route path="/menu/cupcakes" element={<Cupcakes />} />
                        <Route path="/menu/cookies" element={<Cookies />} />
                        <Route path="/menu/cakesicles" element={<Cakesicles />} />
                        <Route path="/menu/tarts-bars-brownies" element={<TartsBarsBrownies />} />
                        {SERVICES_ENABLED && (
                            <>
                                <Route path="/services" element={<Services />} />
                                <Route path="/services/private-events" element={<PrivateEvents />} />
                                <Route path="/services/corporate-events" element={<CorporateEvents />} />
                                <Route path="/services/weddings" element={<Weddings />} />
                                <Route path="/services/holiday-orders" element={<HolidayOrders />} />
                                <Route path="/services/equipment-rental" element={<EquipmentRental />} />
                            </>
                        )}
                        <Route path="/gallery" element={<Gallery />} />
                        <Route path="/classes" element={<Classes />} />
                        <Route path="/order" element={<Order />} />
                        <Route path="/faqs" element={<FAQs />} />
                        <Route path="*" element={<NotFound />} />
                    </Routes>
                </div>
                {isMobile && <MobileFooter />}
                {!isMobile && <MainFooter />}
            </div>
        </Router>
    );
}

export default App;
